import { useEffect } from "react";
import { useState, useRef } from "react";


window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

const useSpeechRecognition = setRecognizedText => {
    const [text, setText] = useState("");
    const [recording, setRecording] = useState(false);
    const speechRecognition = useRef();

    const startRecognition = () => {
        try {
            speechRecognition.current?.abort();
            speechRecognition.current = null;
            
            speechRecognition.current = new window.SpeechRecognition();
            speechRecognition.current.interimResults = true;
            speechRecognition.current.lang = 'it-IT';
            
            speechRecognition.current.onresult = e => {
                let recognized = Array.from(e.results)
                    .map(result => result[0])
                    .map(result => result.transcript)
                    .join('');
        
                setRecognizedText(recognized.toLowerCase());
                setText(recognized.toLowerCase());
            };

            speechRecognition.current.onend = () => setRecording(false);

            speechRecognition.current.start();
            setRecording(true);
        } catch (err) {
            console.warn(`Error with speechRecognition: ${err}`);
        }
    };

    const stopRecognition = () => {
        try {
            setRecording(false);
            speechRecognition.current?.abort();
        } catch (err) {
            console.warn(`Error with speechRecognition: ${err}`);
        }
    };

    useEffect(() => {
        return () => {
            speechRecognition.current?.abort();
            speechRecognition.current = null;
        }
    }, []);

    return { text, recording, startRecognition, stopRecognition };
};

export default useSpeechRecognition